import { render } from "./FullListOfAmenitiesPreview.vue?vue&type=template&id=62eb708b&scoped=true"
import script from "./FullListOfAmenitiesPreview.vue?vue&type=script&lang=js"
export * from "./FullListOfAmenitiesPreview.vue?vue&type=script&lang=js"

import "./FullListOfAmenitiesPreview.vue?vue&type=style&index=0&id=62eb708b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62eb708b"]])

export default __exports__